import { isObject, isValueEmpty } from '../utils';
export function valueContains(givenValue, expectedValue) {
    if (isValueEmpty(givenValue)) {
        return false;
    }
    if (isObject(givenValue)) {
        return Object.values(givenValue).includes(expectedValue);
    }
    if (Array.isArray(givenValue) || typeof givenValue === 'string') {
        return givenValue.indexOf(expectedValue) > -1;
    }
    throw new Error(`Contains operator: Unsupported values to compare ${JSON.stringify(givenValue)}, ${JSON.stringify(expectedValue)}`);
}
//# sourceMappingURL=contains.js.map